import script from "./Page3.vue?vue&type=script&setup=true&lang=js"
export * from "./Page3.vue?vue&type=script&setup=true&lang=js"

import "./Page3.vue?vue&type=style&index=0&id=4e72027e&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-4e72027e"]])

export default __exports__